// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\JobOrder\ApiJobOrderVersion.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { JobOrderSelf, JobOrderSelfData, JobOrderSelfOptions } from 'data/models/JobOrderSelf';
import { JobOrderVersion as _JobOrderVersion, JobOrderVersionData as _JobOrderVersionData, JobOrderVersionOptions as _JobOrderVersionOptions } from 'data/models/JobOrderVersion';
import { PortCallSelf, PortCallSelfData, PortCallSelfOptions } from 'data/models/PortCallSelf';
import { QuickBooksJobTracking, QuickBooksJobTrackingData, QuickBooksJobTrackingOptions } from 'data/models/QuickBooksJobTracking';

// JobOrderVersionData is the class that JobOrderVersion serializes to/from
export interface JobOrderVersionData {
    ChangeId : number;
    Id : number;
	
    Change : ChangeData | null;
    EventsAbout : EventData[] | null;
    EventsReferencing : EventData[] | null;
    NextVersion : _JobOrderVersionData[] | null;
    PortCall : PortCallSelfData | null;
    PortCallId : number;
    PrevChange : ChangeData | null;
    PrevChangeId : number | null;
    PrevVersion : _JobOrderVersionData | null;
    Self : JobOrderSelfData | null;
	
    Billable : boolean;
    Deleted : boolean;
    ExtraDataJSON : string | null;
    Guid : /* GUID */ string;
    QBTracking : QuickBooksJobTrackingData;
}

// JobOrderVersionOptions is the class which may be passed to the JobOrderVersion constructor to define optional initial data values
export interface JobOrderVersionOptions {
    ChangeId : number;
    Id : number;
	
    Change? : ChangeOptions | null;
    EventsAbout? : EventOptions[] | null;
    EventsReferencing? : EventOptions[] | null;
    NextVersion? : _JobOrderVersionOptions[] | null;
    PortCall? : PortCallSelfOptions | null;
    PortCallId? : number;
    PrevChange? : ChangeOptions | null;
    PrevChangeId? : number | null;
    PrevVersion? : _JobOrderVersionOptions | null;
    Self? : JobOrderSelfOptions | null;
	
    Billable? : boolean;
    Deleted? : boolean;
    ExtraDataJSON? : string | null;
    Guid? : /* GUID */ string;
    QBTracking? : QuickBooksJobTrackingOptions;
}

export class JobOrderVersion {
    public ChangeId : DataSignal<number>;
    public Id : DataSignal<number>;
	
    public Change : DataSignal<Change | null>;
    public EventsAbout : SDataArray<Event>;
    public EventsReferencing : SDataArray<Event>;
    public NextVersion : SDataArray<_JobOrderVersion>;
    public PortCall : DataSignal<PortCallSelf | null>;
    public PortCallId : DataSignal<number>;
    public PrevChange : DataSignal<Change | null>;
    public PrevChangeId : DataSignal<number | null>;
    public PrevVersion : DataSignal<_JobOrderVersion | null>;
    public Self : DataSignal<JobOrderSelf | null>;
	
    public Billable : DataSignal<boolean>;
    public Deleted : DataSignal<boolean>;
    public ExtraDataJSON : DataSignal<string | null>;
    public Guid : DataSignal<string>;
    public QBTracking : QuickBooksJobTracking;

    constructor();
    constructor(data : JobOrderVersionOptions);
    constructor(data: JobOrderVersionOptions | null = null) {
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Change = S.value<Change | null>(null);
        this.EventsAbout = SArray<Event>([]);
        this.EventsReferencing = SArray<Event>([]);
        this.NextVersion = SArray<_JobOrderVersion>([]);
        this.PortCall = S.value<PortCallSelf | null>(null);
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.PrevChange = S.value<Change | null>(null);
        this.PrevChangeId = jsonableObservable(S.value<number | null>(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = S.value<_JobOrderVersion | null>(null);
        this.Self = S.value<JobOrderSelf | null>(null);
	    
        this.Billable = jsonableObservable(S.value<boolean>(data && data.Billable !== undefined ? data.Billable : false));
        this.Deleted = jsonableObservable(S.value<boolean>(data && data.Deleted !== undefined ? data.Deleted : false));
        this.ExtraDataJSON = jsonableObservable(S.value<string | null>(data && data.ExtraDataJSON !== undefined ? data.ExtraDataJSON : null));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking();
    }

    static key(obj : JobOrderVersion) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    }
    
    static dataKey(obj : JobOrderVersionOptions) {
        return obj.ChangeId + '\u2618' + obj.Id;
    }

    static update(obj : JobOrderVersion, data : JobOrderVersionOptions) {
        S.freeze(() => {
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
            if (data.PrevChangeId !== undefined) obj.PrevChangeId(data.PrevChangeId);
	        
            if (data.Billable !== undefined) obj.Billable(data.Billable);
            if (data.Deleted !== undefined) obj.Deleted(data.Deleted);
            if (data.ExtraDataJSON !== undefined) obj.ExtraDataJSON(data.ExtraDataJSON);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.QBTracking !== undefined) QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/JobOrderVersion.ts